import classNames from 'classnames';
import type { FC, ReactNode } from 'react';

import { Text } from '@revelio/ui';

import { ContactSalesButton } from '../../../trialUser/ContactSalesButton';
import { CentrializedLayout } from './centralized-layout';
import styles from './trial-page-content.module.css';

interface TrialPageContentProps {
  children?: React.ReactNode;
}

const SimpleCard: FC<{ className?: string; children?: ReactNode }> = ({
  className,
  children,
}) => {
  return <div className={classNames(styles.card, className)}>{children}</div>;
};

export const TrailPageConent: FC<TrialPageContentProps> = ({ children }) => {
  return (
    <CentrializedLayout>
      <div className={styles.cards}>
        <SimpleCard className={styles.introCard}>{children}</SimpleCard>
        <SimpleCard className={styles.contactCard}>
          <div className={styles.contactBody}>
            <div className={styles.contactText}>
              <Text
                as="h1"
                fontSize="lg"
                weight="semibold"
                className={styles.title}
              >
                Contact Sales To Unlock
              </Text>
              <Text>Gain full access by contacting our sales team.</Text>
            </div>
            <ContactSalesButton
              buttonProps={{ className: styles.contactSales }}
            />
          </div>
        </SimpleCard>
      </div>
    </CentrializedLayout>
  );
};
